import { defineStore } from 'pinia';
import { reactive } from 'vue';

export const useFaderStore = defineStore('faders', () => {
  // Use a reactive object to track multiple fader states
  const faders = reactive({});

  // Helper to ensure a fader exists in the store
  const getFader = (id) => {
    if (!faders[id]) {
      faders[id] = { volume: 100, isMuted: false };
    }
    return faders[id];
  };

  return { faders, getFader };
});

